// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xvQ4q","textContent":"styles_textContent__g8fno","label":"styles_label__mSwXn","description":"styles_description__7pvrF"};